<template>
  <v-container id="pedidos" tag="section">
    <base-v-component heading="Pedidos internos " />
    <base-material-card color="indigo" icon="mdi-account-multiple" inline class="px-5 py-3">
      <v-toolbar flat color="white">
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="pedidosInternos"
        :loading="loading"
        :search="search"
        :must-sort="true"
        sort-by="numPedidoInternos"
        :sort-desc="true"
      >
        <!--:return-value.sync="item.estado.value"-->
        <template v-slot:item.estado="{ item }">
          <v-edit-dialog
            :return-value.sync="item.estado"
            large
            persistent
            @save="save(item)"
            save-text="Cambiar estado"
            cancel-text="Cancelar"
          >
            <div>{{item.estado.text}}</div>
            <template v-slot:input>
              <div class="mt-4 title">Cambiar estado</div>
            </template>
            <template v-slot:input>
              <v-select
                :loading="loadingSelect"
                @change="cambioEstado(item)"
                v-model="item.estado"
                label="Estado pedido interno"
                :items="estados"
              ></v-select>
            </template>
          </v-edit-dialog>
        </template>
        <template v-slot:item.acciones="{ item }">
          <v-row>
            <v-tooltip top v-if="item.estado.value != 'realizando'">
              <template v-slot:activator="{ on }">
                <v-btn
                  class="px-2 ml-1"
                  color="green"
                  min-width="0"
                  small
                  v-on="on"
                  :loading="loadingExcel"
                  @click="goExcel(item)"
                >
                  <v-icon small>mdi-file-excel</v-icon>
                </v-btn>
              </template>
              <span>Excel pedido interno</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      loadingExcel: false,
      loadingSelect: false,
      loading: false,
      search: "",
      headers: [
        {
          sortable: false,
          text: "Id",
          value: "numPedidoInternos",
        },
        {
          sortable: false,
          text: "Fecha",
          value: "fechaEspera",
        },
        {
          sortable: false,
          text: "Restaurante",
          value: "restaurante",
        },
        {
          sortable: false,
          text: "Fecha Enviado",
          value: "fechaEnviado",
        },
        {
          sortable: false,
          text: "Estado",
          value: "estado",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      //pedidosInternos: state => state.internos.pedidos
      estados: (state) => state.internos.estados,
      catInternas: (state) => state.internos.categorias,
      impuestos: (state) => state.impuestos.impuestosArray,
    }),
    ...mapGetters({
      pedidosInternos: "internos/getPedidosInternosNegocio",
    }),
  },
  methods: {
    reload() {
      this.getPedidos();
    },
    getPedidos() {
      this.loading = true;
      let _vm = this;
      return this.$store
        .dispatch("internos/getPedidosInternosNegocio")
        .finally(() => {
          _vm.loading = false;
        });
    },
    /** Deprecated, se gestiona en front*/
    /*
    goExcel(item) {
      const _vm = this;
      _vm.loadingForm = true;
      this.$store
        .dispatch("internos/generarExcel", item)
        .then(r => {
          if (r.ok) {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj:
                "Se ha programado el informe, en breve recibirá una mensaje en su centro de notificaciones"
            });
          } else {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al programar el informe"
            });
          }
        })
        .catch(e => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al programar el informe: " + e
          });
        })
        .finally(() => {
          _vm.loadingForm = false;
        });
    },*/
    goExcel(item) {
      const _vm = this;

      if (item.ficheroUrl) {
        _vm.goFile(item);
      } else {
        _vm.loadingExcel = true;
        this.$store
          .dispatch("internos/generarExcel", item)
          .then((r) => {
            if (r.ok) {
              _vm.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Informe generado",
              });
              item.ficheroUrl = r.fichero;
              _vm.goFile(item);
            } else {
              _vm.$store.commit("snackbar/setMensajeDanger", {
                msj: "Error al programar el informe",
              });
            }
          })
          .catch((e) => {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al programar el informe: " + e,
            });
          })
          .finally(() => {
            _vm.loadingExcel = false;
          });
      }
    },
    goFile(item) {
      window.open(item.ficheroUrl, "_blank");
    },
    save(item) {
      var _vm = this;
      _vm.loadingSelect = true;
      this.$store
        .dispatch("internos/cambiarEstado", item)
        .then(() => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Estado cambiado",
          });
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al cambiar el estado: " + e,
          });
        })
        .finally(() => {
          this.getPedidos();
          _vm.loadingSelect = false;
        });
    },
    cambioEstado(e, i) {
      console.log(e);
      console.log(i);
    },
  },
  mounted() {
    this.getPedidos();
  },
};
</script>

<style>
</style>